import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/database';


var firebaseConfig = {
  apiKey: "AIzaSyCDxNc2c3R9AkVdDaOSaWulQuD44-gyvRE",
  authDomain: "co-diabetico-paciente.firebaseapp.com",
  databaseURL: "https://co-diabetico-paciente-default-rtdb.firebaseio.com",
  projectId: "co-diabetico-paciente",
  storageBucket: "co-diabetico-paciente.appspot.com",
  messagingSenderId: "622380923253",
  appId: "1:622380923253:web:0e4ec0744c8cbf5419bb3c",
  measurementId: "G-7GFVVZQ0M7"
};


// Get a Firestore instance
const app = firebase
  .initializeApp(firebaseConfig);
firebase.analytics();
const firestore = app.firestore();
firestore.enablePersistence();

export const db = firestore;
export const rdb = app.database();

export const storage = firebase.storage(app);
export const auth = app.auth();

export const FieldValue = firebase.firestore.FieldValue;
export const FieldPath = firebase.firestore.FieldPath;
export const TaskState = firebase.storage.TaskState;

